// extracted by mini-css-extract-plugin
export var text = "_91-0";